export default __webpack_public_path__ + "static/media/GT-Cinetype-Bold.c40b33f7.ttf";